import * as React from "react";
import { forwardRef } from "react";
const SvgAprovar = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={15} fill="none" viewBox="0 0 20 15" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="#206021" d="M6.648 14.025 0 7.377l1.662-1.662 4.986 4.986L17.349 0l1.662 1.662z" /></svg>;
const ForwardRef = forwardRef(SvgAprovar);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNjQ4MDMgMTQuMDI1TDAgNy4zNzY5OEwxLjY2MjAxIDUuNzE0OTdMNi42NDgwMyAxMC43MDFMMTcuMzQ5IDBMMTkuMDExIDEuNjYyMDFMNi42NDgwMyAxNC4wMjVaIiBmaWxsPSIjMjA2MDIxIi8+Cjwvc3ZnPgo=";